import React, { createContext, useContext, useEffect, useState } from 'react';
import { AppConfig } from './config';

const ConfigContext = createContext<AppConfig | null>(null);

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error cargando config.json: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setConfig(data);
        setGlobalConfig(data); // Configurar globalmente para uso fuera de React
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading config:', error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#333'
      }}>
        Cargando configuración...
      </div>
    );
  }

  if (error || !config) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        color: '#d32f2f'
      }}>
        <h2>Error cargando configuración</h2>
        <p>{error || 'Configuración no disponible'}</p>
      </div>
    );
  }

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): AppConfig => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig debe ser usado dentro de ConfigProvider');
  }
  return context;
};

// Hook auxiliar para obtener config de forma segura en funciones no-React
let globalConfig: AppConfig | null = null;

export const setGlobalConfig = (config: AppConfig) => {
  globalConfig = config;
};

export const getGlobalConfig = (): AppConfig => {
  if (!globalConfig) {
    throw new Error('Config no ha sido inicializado aún');
  }
  return globalConfig;
};
